<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-card no-body class="notification-config-card">
        <b-tabs v-model="tabIndex" active-nav-item-class="font-weight-bold text-uppercase text-dark">

          <b-tab>
            <template #title><AppIcon name="mail" class="mr-1" /> Email</template>
            <div class="notification-config-tab">
              <div class="notification-config-section-heading">
                <div>
                  <h5>Email</h5>
                  <p>Servidor SMTP para envíos automáticos y manuales.</p>
                </div>
                <span class="notification-status" :class="statusClass(crud.email.active)">
                  <span class="notification-status__dot"></span>
                  {{ statusText(crud.email.active) }}
                </span>
              </div>

              <b-row>
                <b-col lg="6" sm="12">
                  <b-row>
                    <b-col md="6">
                      <b-form-group label="Servidor">
                        <b-form-input type="text" size="sm" v-model="crud.email.host" placeholder="mail.example.com"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <b-form-group label="Puerto">
                        <b-form-input type="number" size="sm" v-model="crud.email.port" placeholder="25"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <b-form-group label="Cifrado">
                        <b-form-input type="text" size="sm" v-model="crud.email.encryption" placeholder="tls"></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col md="6">
                      <b-form-group label="Usuario">
                        <b-form-input type="text" size="sm" v-model="crud.email.username" placeholder="example@example.com"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group label="Contraseña">
                        <b-input-group class="w-100" size="sm">
                          <b-form-input :type="password.typePassword" size="sm" v-model="crud.email.password" placeholder="*******"></b-form-input>
                          <b-input-group-append>
                            <b-button variant="outline-secondary" size="sm" @click="changeTypePassword()" v-b-tooltip.hover title="Mostrar u ocultar contraseña" aria-label="Mostrar u ocultar contraseña">
                              <AppIcon :name="password.iconPassword" />
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col md="6">
                      <b-form-group label="Nombre Remitente">
                        <b-form-input type="text" size="sm" v-model="crud.email.fromName" placeholder="example"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group label="Email Remitente">
                        <b-form-input type="text" size="sm" v-model="crud.email.fromAddress" placeholder="example@example.com"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <div class="notification-config-actions">
                    <b-button variant="dark" size="sm" @click="saveEmail()">
                      <AppIcon name="save" class="mr-1" />Guardar
                    </b-button>
                  </div>

                  <div class="notification-test-panel">
                    <b-form-group label="Email de prueba">
                      <b-form-input type="text" size="sm" v-model="crud.email.emailTest" placeholder="Ingrese un email para enviar la prueba"></b-form-input>
                    </b-form-group>
                    <b-button variant="outline-dark" size="sm" @click="testEmail()">
                      <AppIcon name="send" class="mr-1" />Probar conexión
                    </b-button>
                  </div>
                </b-col>

                <b-col lg="6" sm="12">
                  <section class="notification-help-panel">
                    <div class="notification-help-panel__header">
                      <span class="notification-help-panel__icon"><AppIcon name="mail" /></span>
                      <div>
                        <h6>Implementación</h6>
                        <p>SMTP para emails salientes del sistema.</p>
                      </div>
                    </div>

                    <p>Esta configuración se usa para alertas automáticas, envíos manuales y recuperación de contraseña.</p>

                    <div class="notification-help-block">
                      <h6>Proveedor recomendado</h6>
                      <p>Conviene usar un servicio transaccional porque mejora la entregabilidad y permite auditar envíos.</p>
                      <ul>
                        <li><a href="https://mailgun.com" target="_blank">Mailgun</a></li>
                        <li><a href="https://mailtrap.io" target="_blank">Mailtrap</a></li>
                        <li><a href="https://sendgrid.com/" target="_blank">Sendgrid</a></li>
                      </ul>
                    </div>

                    <div class="notification-help-block">
                      <h6>Datos clave</h6>
                      <ul>
                        <li><b>Servidor</b>: host SMTP del proveedor, por ejemplo <code>smtp.mailgun.org</code>.</li>
                        <li><b>Puerto/Cifrado</b>: <code>587/tls</code>, <code>465/ssl</code> o <code>25</code> sin cifrado.</li>
                        <li><b>Remitente</b>: nombre y email visibles para el destinatario.</li>
                      </ul>
                    </div>
                  </section>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab>
            <template #title><AppIcon name="notifications" class="mr-1" /> Push</template>
            <div class="notification-config-tab">
              <div class="notification-config-section-heading">
                <div>
                  <h5>Push</h5>
                  <p>Notificaciones Web Push con claves VAPID.</p>
                </div>
                <span class="notification-status" :class="statusClass(crud.push.active)">
                  <span class="notification-status__dot"></span>
                  {{ statusText(crud.push.active) }}
                </span>
              </div>

              <b-row>
                <b-col lg="6" sm="12">
                  <b-form-group label="VAPID Public Key">
                    <div class="vapid-key-chip" :class="{ 'vapid-key-chip--empty': !crud.push.vapidPublicKey }">
                      <AppIcon name="key-fill" class="vapid-key-chip__icon" />
                      <span>{{ crud.push.vapidPublicKey || 'Se autogenera al crear la configuración' }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group label="VAPID Private Key">
                    <div class="vapid-key-chip" :class="{ 'vapid-key-chip--empty': !crud.push.vapidPrivateKey }">
                      <AppIcon name="lock-fill" class="vapid-key-chip__icon" />
                      <span>{{ crud.push.vapidPrivateKey || 'Se autogenera al crear la configuración' }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group label="Subject (mailto: o URL de contacto)">
                    <b-form-input type="text" size="sm" v-model="crud.push.subject" placeholder="mailto:contacto@empresa.com"></b-form-input>
                  </b-form-group>

                  <div class="notification-config-actions">
                    <b-button variant="dark" size="sm" @click="savePush()">
                      <AppIcon name="save" class="mr-1" />Guardar
                    </b-button>
                  </div>

                  <div class="notification-test-panel notification-test-panel--actions">
                    <b-button variant="outline-dark" size="sm" @click="testPush()">
                      <AppIcon name="send" class="mr-1" />Probar conexión
                    </b-button>
                    <b-button variant="outline-danger" size="sm" @click="regeneratePush()">
                      <AppIcon name="refresh" class="mr-1" />Regenerar claves
                    </b-button>
                  </div>
                </b-col>

                <b-col lg="6" sm="12">
                  <section class="notification-help-panel">
                    <div class="notification-help-panel__header">
                      <span class="notification-help-panel__icon"><AppIcon name="notifications" /></span>
                      <div>
                        <h6>Implementación</h6>
                        <p>Web Push nativo del navegador.</p>
                      </div>
                    </div>

                    <p>No requiere configurar proyectos externos: el sistema genera y administra las claves VAPID.</p>

                    <div class="notification-help-block">
                      <h6>Uso de las claves</h6>
                      <ul>
                        <li>Las claves se generan al crear la configuración inicial.</li>
                        <li>El <b>Subject</b> identifica un contacto de referencia exigido por VAPID.</li>
                        <li><b>Regenerar claves</b> invalida las suscripciones existentes y obliga a los usuarios a volver a aceptar push.</li>
                      </ul>
                    </div>
                  </section>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab>
            <template #title><AppIcon name="inbox" class="mr-1" /> Interna</template>
            <div class="notification-config-tab">
              <div class="notification-config-section-heading">
                <div>
                  <h5>Interna</h5>
                  <p>Canal propio dentro del sistema.</p>
                </div>
                <span class="notification-status notification-status--active">
                  <span class="notification-status__dot"></span>
                  Activo
                </span>
              </div>

              <b-row>
                <b-col lg="6" sm="12">
                  <div class="notification-inline-message notification-inline-message--info">
                    <AppIcon name="info-circle" />
                    <span>Este canal funciona siempre para todos los usuarios con acceso al sistema.</span>
                  </div>
                </b-col>
                <b-col lg="6" sm="12">
                  <section class="notification-help-panel">
                    <div class="notification-help-panel__header">
                      <span class="notification-help-panel__icon"><AppIcon name="inbox" /></span>
                      <div>
                        <h6>Cómo funciona</h6>
                        <p>La notificación no sale del sistema.</p>
                      </div>
                    </div>

                    <ul>
                      <li>Se guarda en la base de datos asociada al destinatario.</li>
                      <li>El usuario la ve en “Mis Notificaciones” al ingresar.</li>
                      <li>Puede marcarla como leída, archivarla o restaurarla.</li>
                    </ul>

                    <div class="notification-inline-message notification-inline-message--warning">
                      <AppIcon name="warning" />
                      <span>Si el usuario no ingresa al sistema, no se entera. Para avisos urgentes conviene combinarla con Email, Push o Whatsapp.</span>
                    </div>
                  </section>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab>
            <template #title><AppIcon name="chat-dots" class="mr-1" /> Whatsapp</template>
            <div class="notification-config-tab">
              <tab-whatsapp></tab-whatsapp>
            </div>
          </b-tab>

          <b-tab>
            <template #title><AppIcon name="sms" class="mr-1" /> SMS</template>
            <div class="notification-config-tab">
              <div class="notification-inline-message notification-inline-message--danger">
                <AppIcon name="warning" />
                <span><b>Sin soporte.</b> El canal SMS ya no está soportado y no puede configurarse. Esta pestaña se mantiene únicamente a modo informativo.</span>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>

      <div class="list-view-footer">
        <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
          <AppIcon name="chevron-double-left" class="mr-1" />Volver
        </b-button>
      </div>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import TabWhatsapp from './settings/crudWhatsapp'

  export default {
    components: {
      TabHeaderActions,
      TabWhatsapp,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.NOTIFICACIONES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'configuration',
          elements: {}
        }, 
        crud: {
          email: {
            id: 1,
            host: '',
            port: 0,
            encryption: '',
            username: '',
            password: '',
            fromName: '',
            fromAddress: '',
            emailTest: '',
            active: false,
          },   
          sms: {
            id: 1,            
            username: '',
            password: '',
            nroTest: '',
            active: false,
          },      
          push: {
            id: 1,
            vapidPublicKey: '',
            vapidPrivateKey: '',
            subject: '',
            active: false,
          }
        },  
        password: {
          typePassword: 'password',
          iconPassword: 'visibility',
        },
        tabIndex: 0     
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    }, 
    mounted () {
      this.showEmail()
      this.showPush()
    },
    methods: {
      statusText(active) {
        return active ? 'Activo' : 'Inactivo'
      },
      statusClass(active) {
        return active ? 'notification-status--active' : 'notification-status--inactive'
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },

      showEmail() {        
        var result = serviceAPI.showEmail(this.crud.email)

        result.then((response) => {
          var data = response.data
          
          this.crud.email.host = data.host_smtp
          this.crud.email.port = data.port_smtp
          this.crud.email.encryption = data.encryption          
          this.crud.email.username = data.username
          this.crud.email.password = data.password
          this.crud.email.fromName = data.from_name
          this.crud.email.fromAddress = data.from_address          
          this.crud.email.active = data.active          
        })
      },
      saveEmail() {
        this.confirmDialog('¿Guardar datos de email?', {
          title: 'Guardar Email',
          icon: 'save',
          okTitle: 'GUARDAR',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.saveEmail(this.crud.email);

            result.then(() => {
              loader.hide()          
              this.showEmail()
              this.$awn.success("Datos de email guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            }) 
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },      
      testEmail() {

        var expreg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        if (!expreg.test(this.crud.email.emailTest)) {          
          this.$awn.alert("No se puede realizar el test sino se ingresa un email válido")          
          return false
        }

        this.confirmDialog('¿Probar configuración de email?', {
          title: 'Configuración de email',
          icon: 'send',
          okTitle: 'PROBAR',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.testEmail(this.crud.email)

            result.then(() => {
              loader.hide()
              this.showEmail()
              this.$awn.success('Conexión en funcionamiento!!')
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            });
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },      

      showSMS() {        
        var result = serviceAPI.showSMS(this.crud.sms)

        result.then((response) => {
          var data = response.data
                              
          this.crud.sms.username = data.username
          this.crud.sms.password = data.password
          this.crud.sms.active = data.active          
        })
      },   
      saveSMS() {
        this.confirmDialog('¿Guardar datos de sms?', {
          title: 'Guardar SMS',
          icon: 'save',
          okTitle: 'GUARDAR',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.saveSMS(this.crud.sms);

            result.then(() => {
              loader.hide()          
              this.showSMS()
              this.$awn.success("Datos de SMS guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            }) 
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },               
      testSMS() {        
        if(this.crud.sms.nroTest.length != 10) {
          this.$awn.alert("No se puede realizar el test sino se ingresa un nro de teléfono válido")
          return false
        }

        this.confirmDialog('¿Probar configuración de SMS?', {
          title: 'Configuración de SMS',
          icon: 'send',
          okTitle: 'PROBAR',
        })
        .then(value => {
          if (value) {        
            let loader = this.$loading.show();
            var result = serviceAPI.testSMS(this.crud.sms)

            result.then(() => {
              loader.hide()
              this.showSMS()
              this.$awn.success('Conexión en funcionamiento!!')
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            });
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })            
      },     

      changeTypePassword() {
        if (this.password.typePassword === 'password') {
          this.password.typePassword = 'text'
          this.password.iconPassword = 'visibility_off'
        } else {
          this.password.typePassword = 'password'
          this.password.iconPassword  = 'visibility'
        }
      }, 
      
      showPush() {        
        var result = serviceAPI.showPush(this.crud.push)

        result.then((response) => {
          var data = response.data

          this.crud.push.vapidPublicKey = data.vapidPublicKey
          this.crud.push.vapidPrivateKey = data.vapidPrivateKey
          this.crud.push.subject = data.subject
          this.crud.push.active = data.active
        })
      },
      savePush() {
        this.confirmDialog('¿Guardar datos de Notificaciones Push?', {
          title: 'Guardar Notificaciones Push',
          icon: 'save',
          okTitle: 'GUARDAR',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.savePush(this.crud.push);

            result.then(() => {
              loader.hide()          
              this.showPush()
              this.$awn.success("Datos de Notificaciones Push guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            }) 
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },      
      testPush() {        
        this.confirmDialog('¿Probar configuración de Notificaciones Push?', {
          title: 'Configuración de Notificaciones Push',
          icon: 'send',
          okTitle: 'PROBAR',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.testPush(this.crud.push)

            result.then(() => {
              loader.hide()
              this.showPush()
              this.$awn.success('Conexión en funcionamiento!!')
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            });
          }
        })
      },
      regeneratePush() {
        this.confirmDialog('Esto invalida las suscripciones actuales: los usuarios van a tener que volver a habilitar las notificaciones. ¿Regenerar las claves VAPID?', {
          title: 'Regenerar claves VAPID',
          icon: 'refresh',
          danger: true,
          okTitle: 'REGENERAR',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.regeneratePush(this.crud.push)

            result.then(() => {
              loader.hide()
              this.showPush()
              this.$awn.success('Claves VAPID regeneradas con éxito')
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            });
          }
        })
      },
    }
  }
</script>

<style scoped>
  .notification-config-card {
    overflow: hidden;
  }
  .notification-config-card ::v-deep .nav-tabs {
    background: var(--app-color-surface);
    border-bottom: 1px solid var(--app-color-border);
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 8px 10px 0;
  }
  .notification-config-card ::v-deep .nav-link {
    align-items: center;
    color: var(--app-color-text-secondary);
    display: inline-flex;
    font-size: var(--app-text-sm);
    gap: 4px;
    white-space: nowrap;
  }
  .notification-config-card ::v-deep .nav-link.active {
    background: var(--app-color-surface);
    border-color: var(--app-color-border) var(--app-color-border) var(--app-color-surface);
    color: var(--app-color-text);
  }
  .notification-config-tab {
    padding: 16px;
  }
  .notification-config-section-heading {
    align-items: flex-start;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .notification-config-section-heading h5 {
    color: var(--app-color-text);
    font-size: var(--app-text-lg);
    font-weight: 700;
    margin: 0;
  }
  .notification-config-section-heading p {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-sm);
    margin: 2px 0 0;
  }
  .notification-status {
    align-items: center;
    border-radius: 999px;
    display: inline-flex;
    flex: 0 0 auto;
    font-size: var(--app-text-xs);
    font-weight: 700;
    gap: 6px;
    padding: 4px 9px;
    text-transform: uppercase;
  }
  .notification-status__dot {
    border-radius: 999px;
    display: inline-block;
    height: 7px;
    width: 7px;
  }
  .notification-status--active {
    background: var(--app-color-success-soft);
    color: var(--app-color-success);
  }
  .notification-status--active .notification-status__dot {
    background: var(--app-color-success);
  }
  .notification-status--inactive {
    background: var(--app-color-danger-soft);
    color: var(--app-color-danger);
  }
  .notification-status--inactive .notification-status__dot {
    background: var(--app-color-danger);
  }
  .notification-config-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 4px;
  }
  .notification-test-panel {
    border-top: 1px solid var(--app-color-border);
    margin-top: 16px;
    padding-top: 14px;
  }
  .notification-test-panel--actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .notification-help-panel {
    background: var(--app-color-surface-subtle);
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-sm);
    padding: 14px;
  }
  .notification-help-panel p {
    margin-bottom: 10px;
  }
  .notification-help-panel ul {
    margin-bottom: 0;
    padding-left: 18px;
  }
  .notification-help-panel li + li {
    margin-top: 5px;
  }
  .notification-help-panel__header {
    align-items: center;
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
  }
  .notification-help-panel__header h6 {
    color: var(--app-color-text);
    font-size: var(--app-text-sm);
    font-weight: 700;
    margin: 0;
  }
  .notification-help-panel__header p {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    margin: 1px 0 0;
  }
  .notification-help-panel__icon {
    align-items: center;
    background: var(--app-color-primary-soft);
    border: 1px solid var(--app-color-primary-200);
    border-radius: 8px;
    color: var(--app-color-primary);
    display: inline-flex;
    flex: 0 0 34px;
    height: 34px;
    justify-content: center;
    width: 34px;
  }
  .notification-help-block {
    border-top: 1px solid var(--app-color-border);
    margin-top: 12px;
    padding-top: 12px;
  }
  .notification-help-block h6 {
    color: var(--app-color-text);
    font-size: var(--app-text-xs);
    font-weight: 700;
    margin-bottom: 6px;
    text-transform: uppercase;
  }
  .notification-inline-message {
    align-items: flex-start;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    display: flex;
    font-size: var(--app-text-sm);
    gap: 8px;
    padding: 10px 12px;
  }
  .notification-inline-message--info {
    background: var(--app-color-info-soft);
    border-color: var(--app-color-info-200);
    color: var(--app-color-info);
  }
  .notification-inline-message--warning {
    background: var(--app-color-warning-soft);
    border-color: var(--app-color-warning-200);
    color: var(--app-color-warning);
    margin-top: 12px;
  }
  .notification-inline-message--danger {
    background: var(--app-color-danger-soft);
    border-color: var(--app-color-danger-200);
    color: var(--app-color-danger);
  }
  .vapid-key-chip {
    align-items: center;
    background: var(--app-color-surface-subtle);
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    color: var(--app-color-text-secondary);
    display: flex;
    font-family: 'Courier New', Courier, monospace;
    font-size: var(--app-text-sm);
    gap: 8px;
    overflow-wrap: anywhere;
    padding: 7px 12px;
  }
  .vapid-key-chip__icon {
    color: var(--app-color-text-muted);
    flex-shrink: 0;
  }
  .vapid-key-chip--empty {
    color: var(--app-color-text-muted);
    font-family: inherit;
    font-style: italic;
  }
  @media (max-width: 767.98px) {
    .notification-config-tab {
      padding: 12px;
    }
    .notification-config-section-heading {
      align-items: flex-start;
      flex-direction: column;
      gap: 8px;
    }
    .notification-config-actions,
    .notification-test-panel--actions {
      align-items: stretch;
      flex-direction: column;
      justify-content: flex-start;
    }
    .notification-config-actions .btn,
    .notification-test-panel .btn {
      justify-content: center;
      width: 100%;
    }
    .notification-help-panel {
      margin-top: 12px;
    }
  }
</style>
